import React, { useMemo } from "react";
import { Offcanvas } from "react-bootstrap";
import closeIcon from "../../../../img/Close_round.png";
import CategorySec from "../../../../User/Home/Components/Homepage/CategorySec/CategorySec";
import { useSelector, useDispatch } from "react-redux";
import { closeCatDD } from "../../../../Redux/Reducer/dropdown";
const ChangeCategory = () => {
  const show = useSelector((state) => state.dropdown.categoryDropdown);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeCatDD());
  };
  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );
  return (
    <Offcanvas
      show={show}
      placement="top"
      onHide={handleClose}
      className="h-auto bg-tr changeAdd-offset changeCategory-offset"
      {...backdrop}
    >
      {/* Body */}

      <img className="plpclose" data-bs-dismiss="offcanvas" src={closeIcon} />
      <Offcanvas.Body className=" bg-white">
        <CategorySec />
      </Offcanvas.Body>
      <div
        onClick={handleClose}
        className="bi bi-x-circle fs-lg mx-auto text-white"
      ></div>
    </Offcanvas>
  );
};

export default ChangeCategory;
